import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const isDocumentTypeQuote = (documentType?: InvoiceDocumentType): boolean =>
  documentType?.toLowerCase() === InvoiceDocumentType.Quote
